import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../../assets/background.jpg';
import { ayeTexts } from '../../../utils/constant';
import { notifyExternalRegistrationResult } from '../utils/external-session-notify';
import FailedSVG from './components/FailedSvg';

export default function FailedScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    notifyExternalRegistrationResult('fail');
  }, []);

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <img
        src={require('../../../assets/logos/aye-logo.png')}
        alt="Aye Logo"
        className="h-8 w-16"
      />

      <div className="mt-4 flex w-full flex-col items-center justify-center">
        <FailedSVG />
      </div>
      <div className="failed-body">
        <div className="failed-bottom">
          <div className="instruction p-10">
            <p className="max-w-lg text-center text-[0.9rem]">
              Something went wrong with your registration. Please try again
              later.
            </p>
          </div>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => navigate('/register')}
          type="button"
          className="w-36 rounded-2xl bg-[#5CB891] px-8 py-2 text-white"
        >
          {ayeTexts.failed_screen.try_again_button}
        </button>
      </div>
    </div>
  );
}
